import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Container } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import SubmitComment from './SubmitComment'
import _ from 'lodash'
import Comment from './Comment'

class NoteDetail extends Component {
  renderComments = () => {
    const { note } = this.props
    return _.map(_.get(note, 'comments', []), (comment, key) => {
      return (
        <Comment key={key} id={key}>
          {comment && comment.commentBody}
        </Comment>
      )
    })
  }

  formLoading = () => {
    return (
      <Form loading={false}>
        <Form.Input label="Title" placeholder="Title" />
        <div className="field">
          <label>Short Text</label>
          <textarea type="text" name="body" placeholder="body" rows="2" />
        </div>
        <Button>Submit</Button>
      </Form>
    )
  }

  listNotes = () => {
    const { note } = this.props
    return (
      <div className="ui inverted segment">
        <div className="ui inverted relaxed divided list">
          <div className="item">
            <div className="content">
              <div className="header">{note && note.title}</div>
              {note && note.body}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { note } = this.props
    return (
      <div style={{ marginTop: '5rem' }}>
        <Container>
          {this.listNotes()}
          <SubmitComment id={this.props.match.params.id} />
          <br />
          {this.renderComments()}
        </Container>
      </div>
    )
  }
}

function mapState(state, ownProps) {
  return {
    note: state.notes[ownProps.match.params.id]
  }
}

export default withRouter(connect(mapState)(NoteDetail))



// WEBPACK FOOTER //
// ./src/components/NoteDetail.js